import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from '/src/components';
import {
  BulkPage,
  DashboardPage,
  PageNotFound,
  SigninPage,
  adjustmentRoutes,
  advancesRoutes,
  alertsRoutes,
  assetsRoutes,
  companiesRoutes,
  lendersRoutes,
  loansRoutes,
  participationsRoutes,
  paymentsRoutes,
  statementsRoutes,
  transactionsRoutes,
  usersRoutes,
} from '/src/pages';
import {
  ForgotPasswordPage,
  ResetPasswordInvalidPage,
  ResetPasswordPage,
  ResetPasswordSuccessPage,
} from '/src/pages/users/password';

export const AppRoutes = () => {
  /** Render */
  return (
    <Routes>
      {/* 404 */}
      <Route path="*" element={<PageNotFound />} />
      {...adjustmentRoutes}
      {...advancesRoutes}
      {...assetsRoutes}
      {...companiesRoutes}
      {...lendersRoutes}
      {...loansRoutes}
      {...participationsRoutes}
      {...paymentsRoutes}
      {...statementsRoutes}
      {...transactionsRoutes}
      {...usersRoutes}
      {...alertsRoutes}

      {/* Auth */}
      <Route path="/signin" element={<SigninPage />} />

      {/* Password */}
      <Route path="/password/forgot" element={<ForgotPasswordPage />} />
      <Route path="/password/reset/:token" element={<ResetPasswordPage />} />
      <Route path="/password/reset/invalid" element={<ResetPasswordInvalidPage />} />
      <Route path="/password/reset/success" element={<ResetPasswordSuccessPage />} />

      {/* Bulk Uploads */}
      <Route
        path="/bulk"
        element={
          <RequireAuth>
            <BulkPage />
          </RequireAuth>
        }
      />

      {/* Dashboard */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
    </Routes>
  );
};
